export default __webpack_public_path__ + "static/media/3801.6132e95e.png";